export default __webpack_public_path__ + "static/media/fridge2-afterA.90116ee0.jpg";